export default "__VITE_ASSET__DvYOmbB$__"